export const RENTAL_POTENTIAL = 'rental_potential'
